import React from 'react';
import '../TopicCard.css';
import { Link } from 'react-router-dom';
import { Panel, Label } from 'react-bootstrap';
import userStore from '../store/UserStore';

export class TopicCard extends React.Component {
  constructor(props) {
      super(props);
      this.state = {
        level: 0
      };
      userStore.registerCallback(this.update.bind(this));
  }

  componentDidMount(){
    this.update();
  }

  update(){
    if (userStore.skillsObj.hasOwnProperty(this.props.topic.key)){
      this.setState({level: userStore.skillsObj[this.props.topic.key].level});
    }
  }

  componentWillUnmount(){
    userStore.unregister(this.update.bind(this));
  }

  render() {
    let bootstrapclass="danger";
    if (parseInt(this.state.level) > 0){
      bootstrapclass="warning";
    }
    if (parseInt(this.state.level) > 6){
      bootstrapclass="success";
    }
        return (
          <Link to={`/skill/${this.props.topic.key}`}>
            <Panel className="container" bsStyle={bootstrapclass}>
              <Panel.Heading>
                  <Panel.Title>
                    {this.props.topic.name} <span style={{float:"right"}}>{this.state.level}/10</span>
                  </Panel.Title>
              </Panel.Heading>
              <Panel.Body>
              <h4>{Object.keys(this.props.topic.cats).map(catid=>{
                return (<Label style={{marginRight: "1em"}} key={catid}>{this.props.topic.cats[catid]}</Label>);
              })}</h4>
              </Panel.Body>
            </Panel>
            </Link>
        );
      }
}



// WEBPACK FOOTER //
// ./src/pages/TopicCard.js